module.exports = __webpack_public_path__ + "img/index06.a3cdb42c.png";